import { render, staticRenderFns } from "./ButtonFilter.vue?vue&type=template&id=2cb34aa2&scoped=true"
import script from "./ButtonFilter.vue?vue&type=script&lang=js"
export * from "./ButtonFilter.vue?vue&type=script&lang=js"
import style0 from "./ButtonFilter.vue?vue&type=style&index=0&id=2cb34aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb34aa2",
  null
  
)

export default component.exports